import cloneDeep from 'lodash/fp/cloneDeep'
import { events, MINIMUM_LUMP_SUM_SELECTED } from './adviserProfileInvestmentMinimumsEditorActions'
import { validiateMoneyField } from '../../../common/forms/validationFunctions'

const initialState = {
  submitting: false,
  loadingInvestmentMinimums: false,
  editingInvestmentMinimums: false,
  investmentMinimumsBeforeEditing: {},
  updatingInvestmentMinimums: false,
  isInvalid: {
    formIsValid: true,
    minimumLumpSum: {
      isInvalid: false,
      message: null
    },
    minimumMonthlyDebitOrder: {
      isInvalid: false,
      message: null
    }
  }
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  const { edit, set } = events
  // not going to copy all the state over because we're using reducer composition.
  // just copying the pieces i want to work with
  switch (action.type) {
    case edit.start:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.editingInvestmentMinimums = true
      newState.investmentMinimumsBeforeEditing = cloneDeep(newState.profile.investmentMinimums)
      return newState
    case edit.stop:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.editingInvestmentMinimums = false
      return newState
    case edit.cancel:
      newState.investmentMinimums = copyInvestmentMinimumsState(newState)
      newState.investmentMinimums.editingInvestmentMinimums = false
      newState.profile.investmentMinimums = cloneDeep(newState.investmentMinimumsBeforeEditing)
      newState.investmentMinimumsBeforeEditing = {}
      return newState
    case set.minimumLumpSum:
      newState.profile.investmentMinimums.minimumLumpSum = action.minimumLumpSum
      newState.investmentMinimums.isInvalid.minimumLumpSum = validiateMoneyField(action.minimumLumpSum, true)
      newState.investmentMinimums.isInvalid.formIsValid = formIsValid(newState.investmentMinimums.isInvalid)
      newState.edited = true
      return newState
    case set.minimumMonthlyDebitOrder:
      newState.profile.investmentMinimums.minimumMonthlyDebitOrder = action.minimumMonthlyDebitOrder
      newState.investmentMinimums.isInvalid.minimumMonthlyDebitOrder = validiateMoneyField(action.minimumMonthlyDebitOrder, true)
      newState.investmentMinimums.isInvalid.formIsValid = formIsValid(newState.investmentMinimums.isInvalid)
      newState.edited = true
      return newState
    case set.allowUnsureInvestors:
      newState.profile.investmentMinimums.allowUnsureInvestors = action.allow
      newState.edited = true
      return newState
    case MINIMUM_LUMP_SUM_SELECTED:
      newState.profile.investmentMinimums.minimumLumpSum = action.minimumLumpSum
      newState.edited = true
  }
  return newState
}

function copyInvestmentMinimumsState (state) {
  var investmentMinimums = cloneDeep(state.investmentMinimums)
  investmentMinimums.isInvalid = cloneDeep(state.investmentMinimums.isInvalid)
  return investmentMinimums
}

function formIsValid (isInvalid) {
  return !isInvalid.minimumLumpSum.isInvalid &&
    !isInvalid.minimumMonthlyDebitOrder.isInvalid
}
